import { FLAGS, IsFlagActive } from '@rover/rsdk/src/modules/Data/Core/FrontendConfiguration';
import { isHomepageUrl } from '@rover/shared/js/constants/roverGeo.constants';
import { SEO_LOCATION_REGEX, SeoSlugEnum } from '@rover/shared/js/constants/seo';
import { parseSeoLocationFromTopLevelSlug } from '@rover/utilities/seo';

const shouldLoadFullStory = (isFlagActive: IsFlagActive, locationPathName: string): boolean => {
  if (isFlagActive(FLAGS.ROLLOUT_SSR_SEARCH_FULLSTORY) && locationPathName.startsWith('/search')) {
    return true;
  }

  if (isFlagActive(FLAGS.ROLLOUT_SSR_HOMEPAGE_FULLSTORY) && isHomepageUrl(locationPathName)) {
    return true;
  }

  if (
    isFlagActive(FLAGS.ROLLOUT_SSR_SITTER_PROFILE_FULLSTORY) &&
    locationPathName.startsWith('/members/')
  ) {
    return true;
  }

  if (
    isFlagActive(FLAGS.ROLLOUT_SSR_CITY_SERVICE_FULLSTORY) &&
    SEO_LOCATION_REGEX.CITY_SERVICE.test(locationPathName) &&
    parseSeoLocationFromTopLevelSlug(locationPathName.replace(/^\/|\/$/g, '')).serviceTypeSlug ===
      SeoSlugEnum.DOG_BOARDING // only rollout to US dog boarding users
  ) {
    return true;
  }

  if (
    isFlagActive(FLAGS.ROLLOUT_SSR_FACILITY_CONTACT_PAGE_FULLSTORY) &&
    locationPathName.startsWith('/daycare-center/') &&
    locationPathName.endsWith('contact/')
  ) {
    return true;
  }

  if (
    isFlagActive(FLAGS.ROLLOUT_SSR_FACILITY_PROFILE_FULLSTORY) &&
    locationPathName.startsWith('/daycare-center/') &&
    !locationPathName.includes('contact')
  ) {
    return true;
  }

  if (
    isFlagActive(FLAGS.ROLLOUT_SSR_FACILITY_BOOKING_SUMMARY_FULLSTORY) &&
    locationPathName.startsWith('/daycare-center-booking-summary/')
  ) {
    return true;
  }

  if (
    isFlagActive(FLAGS.ROLLOUT_SSR_TRAINING_SEARCH_FULLSTORY) &&
    locationPathName.match(/^\/training\/search\/$/i)
  ) {
    return true;
  }

  if (
    isFlagActive(FLAGS.ROLLOUT_SSR_TRAINING_PUBLIC_TRAINER_PROFILE_FULLSTORY) &&
    locationPathName.match(/^\/training\/members\/([-_\w]+)\/$/i)
  ) {
    return true;
  }

  if (
    isFlagActive(FLAGS.ROLLOUT_SSR_TRAINING_CANCEL_BOOKING_FULLSTORY) &&
    locationPathName.match(/^\/training\/account\/conversations\/([\w-]+)\/cancel-cancel\/$/i)
  ) {
    return true;
  }

  return false;
};

export default shouldLoadFullStory;
